/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import _ from 'underscore';
import { Button, Alert, FormGroup, FormControl, ControlLabel, Modal, } from 'react-bootstrap';
import validator from 'email-validator';
import ShipmentWebAPIUtils from 'utils/ShipmentWebAPIUtils';
import DocumentPreview from './stops/DocumentPreview';
import { getSignedUrl, getDocumentsV2 } from '../../../utils/DocumentsAPIUtils';
import { DOCUMENT_STATUSES } from '../documents/Document';
import { showToast } from '../../../stores/ToastStore';
const queryOptions = {
    limit: 1,
    order: {
        field: 'createdAt',
        direction: 'desc',
    },
};
const SendRATEEmailModal = ({ shipment, onHide, show }) => {
    const [rateConfirmationUrl, setRateConfirmationUrl] = useState(null);
    const [rateSentConfirmation, setRateSentConfirmation] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [to, setTo] = useState('');
    const { t } = useTranslation();
    const getInitialState = () => {
        setError(null);
        setIsLoading(false);
        setTo('');
    };
    const addRecipients = (e) => {
        setTo(e.target.value.trim());
    };
    const refreshView = (toHide) => {
        getInitialState();
        if (toHide)
            onHide();
    };
    const refetchTimeoutRef = useRef(0);
    async function generateRateConfirmation(jobId, emails, toSend) {
        if (jobId) {
            const rateConfirmation = await ShipmentWebAPIUtils.generateRateConfirmation(jobId, emails, toSend);
            refreshView();
            let rsStatus = rateConfirmation.status;
            if (rateConfirmation) {
                refetchTimeoutRef.current = setInterval(async () => {
                    var _a, _b;
                    if (rsStatus !== DOCUMENT_STATUSES.PENDING) {
                        clearTimeout(refetchTimeoutRef.current);
                        const { data, errors: signedUrlErrors } = await getSignedUrl(rateConfirmation.key);
                        if (signedUrlErrors) {
                            showToast(t('GET_SIGNED_URL_ERROR'), t('GET_SIGNED_URL_FAILED_WITH_ERROR', {
                                error: signedUrlErrors[0].message,
                            }), 'error');
                            return;
                        }
                        setRateConfirmationUrl((_a = data === null || data === void 0 ? void 0 : data.getSignedUrl) === null || _a === void 0 ? void 0 : _a.signedUrl);
                        setIsLoading(false);
                    }
                    else {
                        const { data, errors: documentErrors } = await getDocumentsV2([rateConfirmation.foreignKeys[0]], 'rate_confirmation', queryOptions);
                        if (documentErrors) {
                            showToast(t('GET_DOCUMENT_ERROR'), t('GET_DOCUMENT_FAILED_WITH_ERROR', {
                                error: documentErrors[0].message,
                            }), 'error');
                            return;
                        }
                        rsStatus = (_b = data.getDocumentsV2.documents[0]) === null || _b === void 0 ? void 0 : _b.status;
                    }
                }, 2000);
            }
        }
    }
    async function sendRateConfirmation(jobId, emails, toSend) {
        const response = await ShipmentWebAPIUtils.sendRateConfirmation(jobId, emails, toSend);
        if (response.entity.success) {
            setIsLoading(false);
            setRateSentConfirmation(response.entity.success);
        }
    }
    const generate = (toSend) => {
        const rateConf_contacts = retrieveRateConfirmationContacts();
        var emails = to.replace(/' '/g, '').split(',');
        emails = rateConf_contacts.concat(emails);
        const filtered = emails.filter(Boolean);
        const invalidEmailAddresses = filtered.filter((ea) => !validator.validate(ea));
        if (invalidEmailAddresses.length > 0) {
            setError(t('VALID_EMAIL_ONLY'));
        }
        else {
            setIsLoading(true);
            generateRateConfirmation(shipment._id, _.uniq(filtered), toSend);
        }
    };
    const send = (toSend) => {
        var emails = to.replace(/' '/g, '').split(',');
        const filtered = emails.filter(Boolean);
        const invalidEmailAddresses = filtered.filter((ea) => !validator.validate(ea));
        if (invalidEmailAddresses.length > 0) {
            setError(t('VALID_EMAIL_ONLY'));
        }
        else {
            setIsLoading(true);
            sendRateConfirmation(shipment._id, _.uniq(filtered), toSend);
        }
    };
    const renderError = () => {
        if (!error) {
            return '';
        }
        return React.createElement(Alert, { bsStyle: "warning" }, error);
    };
    const retrieveRateConfirmationContacts = () => {
        const notifications = shipment.shipper.notification_preferences;
        if (notifications) {
            const rate_type = _.filter(notifications, {
                type: 'rate_confirmation_contacts',
            });
            if (Array.isArray(rate_type) && rate_type.length) {
                return rate_type[0].email.recipients;
            }
        }
        return [];
    };
    let contacts = retrieveRateConfirmationContacts();
    contacts = contacts.filter(Boolean);
    let isEnabled = false;
    if ((Array.isArray(contacts) && contacts.length) || to !== '') {
        isEnabled = true;
    }
    const buttonTitle = isLoading ? t('LOADING') : t('GENERATE');
    return (React.createElement(Modal, { show: show, onHide: onHide },
        React.createElement(Modal.Header, null,
            React.createElement("strong", null, t('RATE_CONFIRMATION'))),
        React.createElement(Modal.Body, null,
            renderError(),
            React.createElement("div", { style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                } }, rateConfirmationUrl && (React.createElement(DocumentPreview, { displayInGridView: true, width: "400px", height: "565px", type: rateConfirmationUrl, url: rateConfirmationUrl, renderDownloadableImage: true }))),
            React.createElement("div", null,
                React.createElement(FormGroup, null,
                    React.createElement(ControlLabel, null, t('RECIPIENT')),
                    React.createElement(FormControl, { placeholder: t('COMMA_SEPARATED_EMAILS'), onChange: (e) => addRecipients(e), type: "text", value: to })))),
        React.createElement(Modal.Footer, null,
            React.createElement(Button, { bsStyle: "danger", type: "button", onClick: onHide }, "Close"),
            React.createElement(Button, { disabled: isLoading, bsStyle: "primary", type: "button", onClick: () => generate() }, buttonTitle),
            React.createElement(Button, { disabled: !isEnabled || isLoading, bsStyle: "primary", type: "button", onClick: () => send(true) }, t('SEND')))));
};
SendRATEEmailModal.prototypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
};
export default SendRATEEmailModal;
